import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';
import App, { store } from './App';
import AppTimelinesMz from './AppTimelinesMz';
import AppTimelinesZm from './AppTimelinesZm';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="/app">
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="timelines/mz" element={<AppTimelinesMz />} />
          <Route path="timelines/zm" element={<AppTimelinesZm />} />
          <Route path="timelines" element={<AppTimelinesZm />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
